import React, {useEffect, useState} from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import Tmdb from "./lib/Tmdb";
import {FullDescription, Home, TopMenu,FullCategory, SearchPage} from './components';
import'../src/App.css';


export default() =>{

  const movieList = ['originals','trending','toprated','animation','action','adventure','comedy','music','horror','romance','fiction','documentary'];
  const [featuredMovieItem, setFeaturedMovieItem] = useState(null);

  useEffect(()=>{
    const loadAll = async () =>{
      let listOfFeatured = await Tmdb.getHomelist('originals','1');
      let featured = listOfFeatured.items.results[Math.floor(Math.random()*(listOfFeatured.items.results.length-1))]
      // tv pois somente retorna tipo serie do originals
      let detailedFeatured = await Tmdb.getAditionalInfo(featured.id, 'tv')
      setFeaturedMovieItem(detailedFeatured)
    }
    loadAll();
  },[]);

  return(
    <BrowserRouter>
      <TopMenu/>
      <Routes>
        <Route  path="/" element={<Home movieList={movieList} featuredItem={featuredMovieItem}/>}></Route>
        <Route  path="/fullDescription/:type/:id" element={<FullDescription/>}></Route>
        <Route path="/FullCategory/:category" element={<FullCategory/>}></Route>
        <Route path="/Search/:query/:urlPageNumber" element={<SearchPage/>}></Route>
      </Routes>
    </BrowserRouter>
  );
}